<h2 mat-dialog-title>{{ this.data.title }}</h2>
<mat-dialog-content>
    <p>{{ this.data.message }}</p>    
</mat-dialog-content>
<mat-dialog-actions>
    <button (click)="confirmed()" mat-raised-button color="primary">YES</button>  
    <button (click)="cancelled()" mat-raised-button>NO</button>
</mat-dialog-actions>